import React, {useState,useEffect } from 'react';
import PeopleCardHover from '../components/PeopleCard.js';
import { LayoutGroup } from "framer-motion"
import '../pages/PeoplePage.css';
import { motion } from "framer-motion";
import Header from "../components/Header"
import AddInnerHtml from '../helpers/AddInnerHtml.js';
import Lodaing from '../components/Loading.js';

// Filter labels shown in the UI, plus legacy WP values still present during migration
const STATUS_ALIASES = {
  Coordination: ["Coordination"],
  "Current Members": ["Current Members", "Full Members"],
  "Former Members": ["Former Members", "Associate Members"],
};

const MEMBER_FILTER_VALUES = [
  "Coordination",
  "Current Members",
  "Former Members",
];

const DEFAULT_MEMBER_FILTERS = ["Coordination", "Current Members"];

const positionOrder = {
  Coordination: 0,
  "Current Members": 1,
  "Full Members": 1,
  "Former Members": 2,
  "Associate Members": 2,
};

const personMatchesFilters = (person, selectedFilters) => {
  const statuses = person.acf?.status || [];
  return selectedFilters.some((filter) =>
    (STATUS_ALIASES[filter] || [filter]).some((alias) => statuses.includes(alias))
  );
};

const PeoplePage = (props) => {
  const { people, utilities } = props;

  // Default: Coordination + Current Members (former members hidden until selected)
  const [memberFilterValue, setMemberFilterValue] = useState(DEFAULT_MEMBER_FILTERS);
  const [memberFilterValueButton, setMemberFilterValueButton] = useState(DEFAULT_MEMBER_FILTERS);

  useEffect(() => {
    if (memberFilterValueButton.length === 0) {
      setMemberFilterValue(DEFAULT_MEMBER_FILTERS);
    } else {
      setMemberFilterValue(memberFilterValueButton);
    }
  }, [memberFilterValueButton]);

  // Loading check AFTER hooks
  if (!people || people.length === 0 || !utilities || utilities.length === 0) {
    return <Lodaing />;
  }

  let currentEntry = utilities.filter(item=>item.id===344);
  let currentText = currentEntry[0]?.acf?.text_content || "";

  // OR match across selected filters; people with both Coordination + Current still appear once
  const filteredPeople = people.filter((person) =>
    personMatchesFilters(person, memberFilterValue)
  );
  
  let sortedPeople = filteredPeople.sort((a, b) => {
    // Sort by position
    const aPositions = a.acf.status; // assume status is an array of positions
    const bPositions = b.acf.status; // assume status is an array of positions
  
    // check if either a or b has a "Coordinator" position, and prioritize them accordingly
    const aIsCoordinator = aPositions.some((p) => p === "Coordination");
    const bIsCoordinator = bPositions.some((p) => p === "Coordination");
    if (aIsCoordinator && !bIsCoordinator) {
      return -1;
    }
    if (!aIsCoordinator && bIsCoordinator) {
      return 1;
    }
  
    // if both have "Coordinator" or neither do, sort by position order
    const aPosition = Math.min(...aPositions.map((p) => positionOrder[p] ?? 99));
    const bPosition = Math.min(...bPositions.map((p) => positionOrder[p] ?? 99));
    if (aPosition !== bPosition) {
      return aPosition - bPosition;
    }
  
    // If positions are equal, sort by name
    const aName = a.acf.name.toUpperCase();
    const bName = b.acf.name.toUpperCase();
    const aLastName = aName.split(" ").pop(); // get last word as family name
    const bLastName = bName.split(" ").pop(); // get last word as family name
    if (aLastName < bLastName) {
      return -1;
    }
    if (aLastName > bLastName) {
      return 1;
    }
    return 0;
  });

  const handleMemberButtonClick = (value) => {
    if (memberFilterValueButton.includes(value)) {
      setMemberFilterValueButton(memberFilterValueButton.filter((v) => v !== value));
    } else {
      setMemberFilterValueButton([...memberFilterValueButton,value]);
    }
  };

  const renderStatusFilterButtons = () => {
    return MEMBER_FILTER_VALUES.map((button) => {
      const active = memberFilterValueButton.includes(button);
      const className = active ? "filter-button people active" : "filter-button people";
      return (
        <button
          key={button}
          type="button"
          className={className}
          onClick={() => {handleMemberButtonClick(button)}}
        >
          {button}
        </button>
      );
    });
  };
  
  let cards = [];

  if (typeof(sortedPeople)=='object' && sortedPeople.length >0){
    cards = sortedPeople.map(people =>
        <PeopleCardHover 
          people = {people.acf}
          projects = {sessionStorage.getItem('projects')}
          glitch = {false}
          key = {`peepid:${people.id}`}
          />
        
      )}

  return (
    <motion.div initial={{opacity:0}} animate={{opacity:1}} exit={{opacity:0}} transition={{ duration: 0.8 }}>
      <Header text={props.text}/>
      <div className="container">
        <div className="subPageDesc">
          <AddInnerHtml text={currentText}/>
        </div>
        <div className="peopleCardContainer">
          <div className="people-filter-wrapper peoplepage" style={{justifyContent:"space-around"}}>
            {renderStatusFilterButtons()}
          </div>
          <div className="card-container people-height" style={{minHeight:"700px"}}>
            <LayoutGroup layoutRoot layout="position">
              {cards}
            </LayoutGroup> 
          </div>
        </div>
      </div>
    </motion.div>
  );
};

export default PeoplePage;